import { isValidDate } from "./isValidDate.js";
function isIsoDate(value) {
  if (typeof value !== "string") {
    return false;
  }
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(value)) {
    return false;
  }
  const date = new Date(value);
  return isValidDate(date) && value === date.toISOString().replace(".000", "");
}
export {
  isIsoDate
};
